<template>
	<div id="contactFrameLoading" class="loaderframe component">
		<div class="preloader loading">
			<span class="slice"></span> 
			<span class="slice"></span> 
			<span class="slice"></span> 
			<span class="slice"></span> 
			<span class="slice"></span> 
			<span class="slice"></span>
		</div>
		<p>Gegevens ophalen...</p>
	</div>
</template>

<script> 

export default {
	name: 'loader-component'
}

</script>




// WEBPACK FOOTER //
// loader.vue?793b77d9